module.exports = __webpack_public_path__ + "static/media/noPhoto.00f38cae.webp";